import { Outlet, useLoaderData } from "react-router-dom";

import Navigation from "../../../../../navigations/view-management/detail/navigation";
import RIGHT_PANEL_TABS_TEMPLATE from "../../config/right-panel-tabs.template";

export default function DetailTabLayout({ viewName, activeTab }) {
  const { id } = useLoaderData();
  const tabs = RIGHT_PANEL_TABS_TEMPLATE[viewName] ?? [];

  return (
    <Navigation viewName={viewName} id={id} activeTab={activeTab} tabs={tabs}>
      <Outlet />
    </Navigation>
  );
}
